// extracted by mini-css-extract-plugin
export default {"hrPackageButtonRow":"_1jz6h94r2oG4wLkrYeLwBK","hrPackageButton":"_27AtrI046vamqCJL6BeOtk","scrollable":"_11RBJAEroTy6H5ER70r_TR","hrPackageButtonWrapper":"_29ZiIwGpT25JFrqWch7A50"};